import React from 'react';
import '../../App.css';

// i18n
import {withTranslation} from 'react-i18next';

// Routes
import {withRouter, Switch, Route} from 'react-router-dom';

import styled from 'styled-components';

import AppMenu from './appMenu';
import BookMenu from './bookMenu';
import BookContentMenu from './bookContentMenu';
import {MediaQuery} from '../../constants/size';

const StyledMenu = styled.nav.attrs({className: 'br-app-menu'})`
  background: #122c2e;
  color: #eff7f5;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  > .item { border-bottom: 1px solid rgba(222, 241, 238, 0.11); color: inherit; display: block; padding: 12px 18px; }
  > button.item { cursor: pointer; font: inherit; min-height: 44px; text-align: left; width: 100%; }
  > .item.active { background: #245d5c; border-left: 4px solid #7ad7ca; color: #fff; }
  > .item .br-app-icon-wrapper { margin-right: 6px; }
  > .item:focus-visible { outline: 2px solid var(--br-focus); outline-offset: -2px; }
  ${MediaQuery.phone} {
    height: 100vh;
  }
  ${MediaQuery.tablet} {
    height: 100%;
  }
`;

const ApplicationMenuContainer = ({t}) => {
  return (
    <StyledMenu aria-label={t('Navigation', 'Application navigation')}>
      <Switch key='submenu'>
        <Route path='/books' component={BookMenu} />
        <Route path='/read' component={BookContentMenu} />
        <Route component={AppMenu} />
      </Switch>
    </StyledMenu>
  );
};

export default withTranslation()(withRouter(ApplicationMenuContainer));
